import { Divider } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import { MouseHoverPopover } from "../../components/MouseHoverPopover";
import { useMsg } from "../../components/Msg/Msg";
import { Notifications } from "../../components/Notifications/Notifications";
import { H1 } from "../../components/Typography";
import { useAuth } from "../Authorization";
import { getCoachPhotoUrl } from "../Coaches/coach.utils";
import { GamificationAwardBadge } from "../Gamification/AwardBadge";
import { GamificationPopover } from "../Gamification/GamificationPopover";
import { dashboardMessages } from "./messages";

export const DashboardHeader = ({ toggleRightMenuIcon }) => {
  const msg = useMsg({ dict: dashboardMessages });
  const { user, isCoach } = useAuth();
  const { username, firstName } = user.data;
  const displayName = firstName || username;

  return (
    <MouseHoverPopover
      renderAnchorEl={(popoverProps) => (
        <>
          <Box
            sx={{
              mt: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexWrap: "nowrap",
                alignItems: "center",
                flexGrow: 1,
                py: 2,
                gap: 2,
                zIndex: MouseHoverPopover.zIndex + 1,
                // zIndex: 1350, // notifications have 1400, popover backdrop 1300
              }}
              {...popoverProps}
            >
              {isCoach && (
                <Avatar variant="circular" src={getCoachPhotoUrl(username)} />
              )}
              <H1>{msg("dashboard.header", { user: displayName })}</H1>
              <GamificationAwardBadge />
            </Box>
            <Notifications />
            {toggleRightMenuIcon}
          </Box>
          <Divider variant="fullWidth" sx={{ mb: 3 }} />
        </>
      )}
    >
      <GamificationPopover />
    </MouseHoverPopover>
  );
};
